module.exports = __webpack_public_path__ + "static/media/emojis2_05.250a894f.svg";